/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/frame_lex': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _fill="none" _stroke="#000"><path pid="0" stroke-width="2" stroke-miterlimit="23" d="M5 5h22v22H5z"/><path pid="1" stroke-width=".5" stroke-miterlimit="10" d="M27 20l4-4-3.998-3.999M12 27l4 4 4-4M5 12l-4 4 4 4.001M20 5l-4-4-4 4"/></g>'
  }
})
